// Angular
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
// Layout
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { AppState } from '../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../core/auth';
import { AngularFireAuth } from '@angular/fire/auth';
import {FirebaseService} from "../../../../services/firebase.service";
import {AngularFireStorage} from "@angular/fire/storage";
import {take} from "rxjs/operators";

@Component({
  selector: 'kt-quick-user-panel',
  templateUrl: './quick-user-panel.component.html',
  styleUrls: ['./quick-user-panel.component.scss']
})
export class QuickUserPanelComponent implements OnInit {
  user$: Observable<User>;
  // Public properties
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_quick_user_close',
    toggleBy: 'kt_quick_user_toggle'
  };
  currentUser

  constructor(
    private store: Store<AppState>,
    private afa: AngularFireAuth,
    private firebase: FirebaseService,
    private cdr: ChangeDetectorRef,
    private afstorage: AngularFireStorage,
  ) {

  }

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.firebase.getCurrentUser() as any;
    this.user$.pipe(take(1)).subscribe((user) => {
      this.currentUser = user;
    });
  }

  /**
   * Log out
   */
  logout() {
    this.afa.signOut().then(() => {
      this.store.dispatch(new Logout());
    }).catch(error => {
      console.log(error)
    })
  }
  changeProfileImg(event, element) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.setImageDownloadUrl(reader.result).then((url) => {
        element.value = '';
        this.cdr.markForCheck();
      });
      this.cdr.markForCheck()
    };
  }

  setImageDownloadUrl(baseImage) {
    const ref = this.afstorage.storage.ref();
    const imgRef = ref.child(`usersPhoto/${this.currentUser.uid}/${Date.now()}`);
    return new Promise((resolve, reject) => {
      imgRef.putString(baseImage, 'data_url').then(() => {
        imgRef.getDownloadURL().then((imageUrl) => {
          resolve(imageUrl);
        })
      })
    });
  }
}
